import { Component, OnInit,Input,SimpleChanges,OnChanges,Output,EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import {ChangeDetectorRef} from '@angular/core';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit,OnChanges {

  loading:boolean=false;
  @Input() userId: any;
  @Output() close = new EventEmitter();

  profileForm: FormGroup;

  constructor(private ref: ChangeDetectorRef, private authService:AuthService) { }

  ngOnInit(): void {
    this.initalizeForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(this.userId);
  }

  closeModal(){
    this.close.emit('close');
  }

  initalizeForm() {
    this.profileForm = new FormGroup({
      newPassowrd: new FormControl(null, {
        updateOn: 'change',
        validators: [Validators.required, Validators.pattern(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,20}/)]
      }),
      confirm_password: new FormControl(null, {
        updateOn: 'change',
        validators: [Validators.required, this.passwordMatcher.bind(this)]
      })
    });

  
  }

  private passwordMatcher(control: FormControl): { [s: string]: boolean } {
    if (
      this.profileForm &&
      (control.value !== this.profileForm.value.newPassowrd)
    ) {
      return { passwordNotMatch: true };
    }
    return null;
  }

  submit(){
    this.loading= true;
    let param ={
      password: this.profileForm.value.newPassowrd,
      repassword:this.profileForm.value.confirm_password
    }
    this.authService.admin_update_password(param,this.userId).subscribe(resp=>{
      this.loading= false;
      if(resp.statusCode == 200 ){
        this.alert2(resp.statusMessage,"success");
      
      }else{
        this.alert2(resp.statusMessage,"error");
      
      }
      this.ref.detectChanges();
    },error=>{
      this.loading= false;
      this.alert2("Failed renew subscription","error");
      this.ref.detectChanges();
    })
  }

  alert2(msg, status) {
    Swal.fire({
      text: msg,
      icon: status,
      buttonsStyling: false,
      confirmButtonText: "Ok",
      customClass: {
        confirmButton: "btn font-weight-bold btn-primary"
      }
    }).then((result) => {
      if (result.value) {
        this.closeModal();
      }

    })
  }

}
